export const isIOSWrapper = window.nativeWrapper?.os === 'iOS';

export const isIOS = isIOSWrapper || /iPad|iPhone|iPod/.test(navigator.userAgent);
